"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRemainingCategoryOptions = exports.getObjectArrayByCategoryIds = exports.getPropertyObjectDigits = exports.getPropertyObjectById = exports.getPropertyNameById = void 0;
const feed_factory_data_properties_ontology_1 = require("@feed-factory/feed-factory.data.properties-ontology");
const getPropertyNameById = (id) => { var _a; return ((_a = (0, exports.getPropertyObjectById)(id)) === null || _a === void 0 ? void 0 : _a.name) || "UNKNOWN"; };
exports.getPropertyNameById = getPropertyNameById;
const getPropertyObjectById = (id) => {
    var _a, _b;
    const ontology = feed_factory_data_properties_ontology_1.propertiesOntology.propertyCategories;
    const digits = (0, exports.getPropertyObjectDigits)(id);
    if (!digits) {
        return null;
    }
    const propertyCategory = ontology.find((item) => {
        const itemDigits = (0, exports.getPropertyObjectDigits)(item.id);
        return (digits === null || digits === void 0 ? void 0 : digits[0]) === (itemDigits === null || itemDigits === void 0 ? void 0 : itemDigits[0]);
    });
    if (digits.length === 1) {
        return propertyCategory;
    }
    const property = (_a = propertyCategory === null || propertyCategory === void 0 ? void 0 : propertyCategory.properties) === null || _a === void 0 ? void 0 : _a.find((item) => {
        const itemDigits = (0, exports.getPropertyObjectDigits)(item.id);
        return (digits === null || digits === void 0 ? void 0 : digits[1]) === (itemDigits === null || itemDigits === void 0 ? void 0 : itemDigits[1]);
    });
    if (digits.length === 2) {
        return property;
    }
    const option = (_b = property === null || property === void 0 ? void 0 : property.options) === null || _b === void 0 ? void 0 : _b.find((item) => {
        const itemDigits = (0, exports.getPropertyObjectDigits)(item.id);
        return (digits === null || digits === void 0 ? void 0 : digits[2]) === (itemDigits === null || itemDigits === void 0 ? void 0 : itemDigits[2]);
    });
    return option || null;
};
exports.getPropertyObjectById = getPropertyObjectById;
// May return 1-3 digits in array, or null
const getPropertyObjectDigits = (id) => {
    var _a, _b;
    // Determine if valid id
    if (((_a = id.match(/[0-9]+(.[0-9]+)?(.[0-9]+)?/)) === null || _a === void 0 ? void 0 : _a[0]) !== id) {
        console.error(`Requested category with invalid ID: ${id}`);
        return null;
    }
    return ((_b = id.match(/[0-9]+/g)) === null || _b === void 0 ? void 0 : _b.map((v) => parseInt(v))) || null;
};
exports.getPropertyObjectDigits = getPropertyObjectDigits;
const getObjectArrayByCategoryIds = (ids) => {
    return ids.map((id) => {
        return (0, exports.getPropertyObjectById)(id.toString());
    });
};
exports.getObjectArrayByCategoryIds = getObjectArrayByCategoryIds;
const getRemainingCategoryOptions = (catIds) => {
    return feed_factory_data_properties_ontology_1.propertiesOntology.propertyCategories
        .filter((cat) => {
        var _a;
        const firstDigit = (_a = (0, exports.getPropertyObjectDigits)(cat.id)) === null || _a === void 0 ? void 0 : _a[0];
        if (!firstDigit) {
            return false;
        }
        return !catIds.find((mainCat) => mainCat === firstDigit);
    })
        .map((cat) => ({ value: cat.id, label: cat.name }))
        .sort((a, b) => {
        return a.label > b.label ? 1 : -1;
    });
};
exports.getRemainingCategoryOptions = getRemainingCategoryOptions;
//# sourceMappingURL=propertiesHelper.js.map